import * as React from "react";
import { ListItemContainer, ListNameLesson, ListNumberLesson } from "./List.styled";
import { LessonStore } from "../../../../../stores/lessons/lesson.store";
import { observer } from "mobx-react";
import { useStores } from "../../../../../stores";
import { useNavigate } from "react-router-dom";
import { GrandChartAccess } from "../../../../../interfaces";
import { Lock } from "../../../../../components/ui/GrandChart/GroupLessonView/Lessons/Lessons.styled";
import { IconLock } from "../../../../../components/common/Icons";

interface ListItemProps {
	nameGroupLesson: string;
	lessonStore: LessonStore;
	access: GrandChartAccess;
	isFirst: boolean;
}

export const ListItem = observer(({ nameGroupLesson, lessonStore, access, isFirst }: ListItemProps) => {
	const { lessonStore: currentLesson, accessLimitedStore } = useStores();
	const navigate = useNavigate();

	const isDisabled = (() => {
		if (access === GrandChartAccess.FULL) {
			return false;
		}

		if (access === GrandChartAccess.DENIED) {
			return true;
		}

		if (access === GrandChartAccess.TRIAL) {
			return !isFirst;
		}

		return true;
	})();

	const handleOnClick = async (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();

		if (isDisabled) {
			accessLimitedStore.modal.open();
			return;
		}

		navigate(`/cabinet/lessons/${lessonStore.uuid}`);
		currentLesson.list.close();
	};

	return (
		<ListItemContainer
			isActive={currentLesson.id === lessonStore.id}
			className={currentLesson.id === lessonStore.id ? "active" : ""}
			onClick={handleOnClick}
		>
			<ListNumberLesson color={lessonStore.color.color}>
				{lessonStore.sort}

				{isDisabled && (
					<Lock style={{ right: -2, bottom: -5 }}>
						<IconLock />
					</Lock>
				)}
			</ListNumberLesson>

			<ListNameLesson>
				{nameGroupLesson} / {lessonStore.name}
			</ListNameLesson>
		</ListItemContainer>
	);
});
